import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Elements } from '@stripe/react-stripe-js'
import { AccountType, AppliedDiscountCodeType } from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { propTypes as formPropTypes, formValues } from 'redux-form'
import { lpForm } from 'lp-form'
import { selectors as memberSelectors } from 'member-reducer'
import { StripeContext } from 'contexts'
import { createStripeOptions } from 'utils/stripeOptions'
import StripePaymentFormContent from './StripePaymentFormContent'

const propTypes = {
  ...formPropTypes,
  account: AccountType,
  autoRenewalAgreement: PropTypes.bool,
  autoRenewalConsent: PropTypes.bool,
  discountCodeDetails: AppliedDiscountCodeType,
  isTrialMembershipsActive: PropTypes.bool,
  onError: PropTypes.func,
  onPaymentMethodCreated: PropTypes.func,
  promoCodeIsTrial: PropTypes.bool,
  showTermsAndConditions: PropTypes.bool,
  shouldSubmitForm: PropTypes.bool,
  stripeClientSecretId: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  termsAgreement: PropTypes.bool,
}

function StripeElementsPaymentForm({
  account = null,
  autoRenewalAgreement = false,
  autoRenewalConsent = false,
  discountCodeDetails = null,
  handleSubmit,
  isTrialMembershipsActive = false,
  onError,
  onPaymentMethodCreated,
  promoCodeIsTrial = false,
  shouldSubmitForm = false,
  showTermsAndConditions = false,
  stripeClientSecretId,
  submitting = false,
  termsAgreement = false,
}) {
  const stripePromise = useContext(StripeContext)

  return (
    <Elements
      stripe={stripePromise}
      options={createStripeOptions(stripeClientSecretId)}
    >
      <StripePaymentFormContent
        account={account}
        autoRenewalAgreement={autoRenewalAgreement}
        autoRenewalConsent={autoRenewalConsent}
        discountCodeDetails={discountCodeDetails}
        handleSubmit={handleSubmit}
        isTrialMembershipsActive={isTrialMembershipsActive}
        onError={onError}
        onPaymentMethodCreated={onPaymentMethodCreated}
        promoCodeIsTrial={promoCodeIsTrial}
        shouldSubmitForm={shouldSubmitForm}
        showTermsAndConditions={showTermsAndConditions}
        submitting={submitting}
        termsAgreement={termsAgreement}
      />
    </Elements>
  )
}

StripeElementsPaymentForm.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: memberSelectors.account(state),
    discountCodeDetails: memberSelectors.discountCodeDetails(state),
    isTrialMembershipsActive: memberSelectors.isTrialMembershipsActive(state),
    promoCodeIsTrial: memberSelectors.promoCodeIsTrial(state),
  }
}

export default compose(
  lpForm({
    name: 'StripeElementsPaymentForm',
    initialValuesFilters: {
      reject: [],
    },
  }),
  formValues('termsAgreement', 'autoRenewalConsent'),
  connect(mapStateToProps, null),
)(StripeElementsPaymentForm)
